import { Injectable } from "@angular/core";
import { PlatformLocation } from "@angular/common";

const languages: string[] = ["ru", "en"];

@Injectable({
	providedIn: "root"
})
export class LanguageService {
	private baseLang: string;

	constructor(
		private platformLocation: PlatformLocation
	) {
		const baseHref = this.platformLocation.getBaseHrefFromDOM();
		this.baseLang = baseHref.split("/")[1];
		const isLang = languages.filter(data => data === this.baseLang).length > 0;
		localStorage.setItem("Language", isLang ? this.baseLang : "ru");
	}

	public getLanguage(): string {
		return localStorage.getItem("Language") || "ru";
	}
}
